import UploadArea from './UploadArea'
import UploadItem from './UploadItem'

const VideoUpload = ({ videos = [], onChange, max = 3,onPreview }) => {
  const handleFilesSelected = (url, file, index, isUploading) => {
    // Phase 1: tạo loading
    if (isUploading) {
      const id = `temp-${Date.now()}-${index}`
      file.__tempId = id

      onChange((prev) => [
        ...prev,
        {
          id,
          name: file.name,
          uploading: true
        }
      ])
      return
    }

    // Phase 2: update url thật
    onChange((prev) =>
      prev.map((v) =>
        v.id === file.__tempId ? { ...v, url, uploading: false } : v
      )
    )
  }

  const handleRemove = (index) => {
    onChange((prev) => prev.filter((_, i) => i !== index))
  }

  return (
    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
      {videos.map((video, index) => (
        <UploadItem
          key={video.id}
          video
          image={video} // reuse UploadItem
          onRemove={() => handleRemove(index)}
          type='video'
          onPreview={onPreview}
        />
      ))}

      {videos.length < max && (
        <UploadArea
          accept="video/*"
          multiple
          maxFiles={max}
          currentCount={videos.length}
          onFilesSelected={handleFilesSelected}
        />
      )}
    </div>
  )
}

export default VideoUpload
